import { render, staticRenderFns } from "./QuestionaireTemplateItem.vue?vue&type=template&id=2bba77cc&scoped=true"
import script from "./QuestionaireTemplateItem.vue?vue&type=script&lang=js"
export * from "./QuestionaireTemplateItem.vue?vue&type=script&lang=js"
import style0 from "./QuestionaireTemplateItem.vue?vue&type=style&index=0&id=2bba77cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bba77cc",
  null
  
)

export default component.exports